@if (actions().length === 0) {
  <div class="flex flex-col items-center gap-2 py-6 text-center">
    <ng-icon name="lucideHistory" class="text-muted-foreground text-2xl" />
    <p class="font-medium">Noch keine Änderungen</p>
    <p hlmMuted class="max-w-md text-sm">
      Sobald eine Agentur in deinem Konto etwas ändert, siehst du es hier.
    </p>
  </div>
} @else {
  <div hlmTableContainer>
    <table hlmTable>
      <thead hlmTHead>
        <tr hlmTr>
          <th hlmTh>Wann</th>
          <th hlmTh>Agentur</th>
          <th hlmTh>Was</th>
        </tr>
      </thead>
      <tbody hlmTBody>
        @for (action of actions(); track $index) {
          <tr hlmTr>
            <td hlmTd class="whitespace-nowrap tabular-nums">
              {{ action.at + 'Z' | date: 'dd.MM.yyyy, HH:mm' }}
            </td>
            <td hlmTd>{{ action.partner_name }}</td>
            <td hlmTd>{{ action.description }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
